<template>
  <HouseDetailsLayout>
    <router-view />
  </HouseDetailsLayout>
</template>
<script>
import HouseDetailsLayout from '@/views/HouseDetailsLayout'

export default {
  name: 'HouseDetails',
  components: { HouseDetailsLayout }
}
</script>
